import { useGetReviewConferenceQuery } from "../../store/api/generated/stock-request-api";
import { isNullish } from "../../lib/util/common-util";
import { useMemo } from "react";
import {
  reviewConferenceMeta,
  ReviewConferenceSaved,
} from "../../lib/object/entity/review-conference";

export function useAppGetReviewConferenceQuery(
  arg: Parameters<typeof useGetReviewConferenceQuery>[0],
  options?: Parameters<typeof useGetReviewConferenceQuery>[1],
  skipOptionalValidations = true, // get系は、skipOptionalValidationsのデフォルトはtrueとする。
): {
  data: ReviewConferenceSaved | null;
  isLoading: ReturnType<typeof useGetReviewConferenceQuery>["isLoading"];
  refetch: ReturnType<typeof useGetReviewConferenceQuery>["refetch"];
  error: ReturnType<typeof useGetReviewConferenceQuery>["error"];
} {
  const {
    data: rawData,
    isLoading,
    refetch,
    error,
  } = useGetReviewConferenceQuery(arg, options);
  const data = useMemo(() => {
    if (isNullish(rawData)) return null;
    return reviewConferenceMeta.toSavedDomainObjectOrNull(
      rawData,
      skipOptionalValidations,
    );
  }, [rawData, skipOptionalValidations]);
  return { data, isLoading, refetch, error };
}
